<div class="accordion" id="menu">
  <div class="card">
    <div class="card-head">
      <div class="d-flex justify-content-center align-items-center bg-gris w-100"  style="height: 35px">
        <a class="text-white text-uppercase" [routerLink]="['/productos']" style="font-size: 16px">Categorias</a>
        <button mat-icon-button class="btn-collapse text-white" color="accent" [matTooltip]="abierto?'Cerrar menu':'Abrir menu'" (click)="abierto=!abierto">
          <span *ngIf="abierto">
            <i class="far fa-minus-square"></i>
          </span>
          <span *ngIf="!abierto">
            <i class="far fa-plus-square"></i>
          </span>
        </button>

      </div>
    </div>
    <div class="collapse" [class.show]="abierto">
      <div class="card-body">
        <ul class="list-group">
          <li class="list-group-item border-0 menu-items-texto menu-items-padding" *ngFor="let m of menu" >
              <a [routerLink]="['/productos']" [queryParams]="{T:m.tipo_codigo,L:m.linea_codigo,R:m.rubro_codigo,F:m.fabrica_codigo}"> {{m.titulo}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
